import script from "./RoomBoxComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomBoxComponent.vue?vue&type=script&setup=true&lang=js"

import "./RoomBoxComponent.vue?vue&type=style&index=0&id=b4bd9a88&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4bd9a88"]])

export default __exports__